import {customerCmdService, customerQueryService} from '../index'
import tokens from '../../utils/tokens'

class Customer {
    getCustomerData = () => customerQueryService.get('customer')
    updateCustomerData = data => customerCmdService.patch('customer', data)
    updateTeamData = (id, data) => customerCmdService.put(`team/${id}`, data)
    updateUsername = data => customerCmdService.put('customer/username', data)
    confirmCode = data => customerCmdService.patch('customer/username', data)
    logAction = data => customerCmdService.post('customer/action', data)
    addFeedback = data => customerCmdService.post('customer/feedback', data)
    setPurchaseInfo = () => customerCmdService.post('organisation/purchase-info')
    getPersonalNotificationChannels = (customerId) => customerQueryService.get(`customer/${customerId}/notification-channels`)
    getTeamNotificationChannels = (teamId) => customerQueryService.get(`team/${teamId}/notification-channels`)
    updatePersonalNotificationChannelStatus = (id, data) => customerCmdService.put(`customer/${id}/notification-channel/enabled`, data)
    updateTeamNotificationChannelStatus = (id, data) => customerCmdService.put(`team/${id}/notification-channel/enabled`, data)
    updatePersonalNotificationChannel = (id, data) => customerCmdService.put(`customer/${id}/notification-channel`, data)
    updateTeamNotificationChannel = (id, data) => customerCmdService.put(`team/${id}/notification-channel`, data)
    addPersonalNotificationChannel = (id, data) => customerCmdService.post(`customer/${id}/notification-channel`, data)
    addTeamNotificationChannel = (id, data) => customerCmdService.post(`team/${id}/notification-channel`, data)
    verifyPersonalNotificationChannel = (id, data) => customerCmdService.patch(`customer/${id}/notification-channel/verification`, data)
    verifyTeamNotificationChannel = (id, data) => customerCmdService.patch(`team/${id}/notification-channel/verification`, data)
    deletePersonalNotificationChannel = (id, priorities) => customerCmdService.delete(`customer/${id}/notification-channel?${priorities}`)
    deleteTeamNotificationChannel = (id, priorities) => customerCmdService.delete(`team/${id}/notification-channel?${priorities}`)
    applyVoucher = data => customerCmdService.post('customer/applied-voucher', data)
    getDeletionReasons = () => customerQueryService.get('deletion-reasons')
    sendPersonalChannelTestAlert = (id, data) => customerCmdService.post(`customer/${id}/notification-channel/test`, data)
    sendTeamChannelTestAlert = (id, data) => customerCmdService.post(`team/${id}/notification-channel/test`, data)
    deleteAccount = data => {
        return customerCmdService.delete('customer', {
            token_type: tokens.accessToken.key, data
        })
    }
    getOrganisationLimitUsages = () => customerQueryService.get('org/usage')
    upgradeOrganisationPlan = () => customerCmdService.put('organisation/plan', null)
    getPlanLimits = (plan, version) => customerQueryService.get(`plan/${plan}/${version}/limits`)
}

export default new Customer()
